export default __webpack_public_path__ + "static/media/img_perfmon-colorBkg.01b330cd.png";